export const DATA_TYPE = {
  object: 'object',
  array: 'array',
  text: 'string',
  number: 'number',
  integer: 'integer',
  boolean: 'boolean',
}
